<div class="layout-column custom-panel full-height edit-availability-container">
  <form class="flex layout-column" #availabilityForm="ngForm" (ngSubmit)="onSubmit()">
    <!-- Header -->
    <div class="layout-row layout-align-start-center header">
      <span class="flex"></span>
      <span *ngIf="!isCreate" class="br-body-2 font-weight-600 primary-100" translate>Edit</span>
      <span *ngIf="isCreate" class="br-body-2 font-weight-600 primary-100" translate>Create</span>
      <span class="flex"></span>
      <bringoz-button type="tertiary"
                      (onClick)="onCancel()">
        <bringoz-icon iconName="close"></bringoz-icon>
      </bringoz-button>
    </div>

    <hr class="main-divider">

    <!-- Scrollable Content Area -->
    <div *ngIf="!loading" class="scroll-content layout-column padding-10 fade-element-in">
      <ng-container *ngFor="let avail of availabilities; let i = index">
        <div class="availability-item layout-column padding-top-10 padding-bottom-10">
          <!-- Status + Times Row -->
          <div class="layout-row layout-align-space-between-start gap-10">
            <div class="status-toggle-container layout-column">
              <div class="status-option available-pill"
                   [class.active]="!avail.disabled"
                   (click)="setAvailabilityStatus(avail, true)" translate>
                Available
              </div>
              <div *ngIf="!isCreate"
                   class="status-option unavailable-pill margin-top-5"
                   [class.active]="avail.disabled"
                   (click)="setAvailabilityStatus(avail, false)" translate>
                Unavailable
              </div>
            </div>

            <div class="layout-column time-inputs-container">
              <div class="time-label" translate>Start</div>
              <app-bringoz-date-picker class="margin-bottom-5"
                [date]="dayStartTime"
                [configTimeZone]="data?.zoneId"
                [placeholder]="'Date' | translate"
                [isHideLabel]="true"
                [isDisabled]="true">
              </app-bringoz-date-picker>
              <app-bringoz-time-select
                [selectedTime]="avail.startTime"
                [ticksInMinutes]="15"
                [min]="dayStartTime"
                [max]="bounds[i]?.isSameDay && avail.endTime ? avail.endTime - 60000 : dayEndTime"
                (onSelect)="onStartTimeChange(avail, $event)">
              </app-bringoz-time-select>
            </div>

            <div class="layout-column time-inputs-container">
              <div class="time-label" translate>End</div>
              <app-bringoz-date-picker class="margin-bottom-5"
                [date]="avail.endTime || dayStartTime"
                [configTimeZone]="data?.zoneId"
                [placeholder]="'Date' | translate"
                [isHideLabel]="true"
                [minDate]="bounds[i]?.endMinDate"
                [maxDate]="bounds[i]?.endMaxDate"
                (onChange)="onEndDateChange(avail, $event)">
              </app-bringoz-date-picker>
              <app-bringoz-time-select
                [selectedTime]="avail.endTime"
                [ticksInMinutes]="15"
                [min]="bounds[i]?.isSameDay && avail.startTime ? avail.startTime + 60000 : (bounds[i]?.endDayStart || dayStartTime)"
                [max]="bounds[i]?.endDayEnd || dayEndTime"
                (onSelect)="onEndTimeChange(avail, $event)">
              </app-bringoz-time-select>
            </div>
          </div>

          <!-- Skills & Territories -->
          <div class="layout-column gap-20 margin-top-10">
            <app-bringoz-multi-select [label]="'Skills' | translate"
                                      [selectedValues]="selectedSkillsForAvail[i]"
                                      [options]="skillsOptions"
                                      (onValueChange)="onSkillsSelectFor(avail, i, $event)">
            </app-bringoz-multi-select>
            <app-branches-multi-select [selectedIds]="avail.branchIds"
                                       [options]="visitPlan.branchReferences"
                                       (onChange)="onBranchesSelectFor(avail, $event.branchIds)">
            </app-branches-multi-select>
          </div>

          <div *ngIf="!locationViews[i]?.showSection"
               class="layout-row layout-align-end-center add-start-end-point-row">
            <bringoz-button type="tertiary"
                            (onClick)="onAddStartEndPoint(avail, i)">
              <span class="br-body-1 font-weight-400 blue-104" translate>+ Add start and end point</span>
            </bringoz-button>
          </div>

          <!-- Addresses -->
          <div *ngIf="locationViews[i]?.showSection"
               class="addresses-section layout-column margin-top-10">
            <span class="br-body-2 font-weight-600 primary-100" translate>Addresses</span>
            <hr class="addresses-divider">
            <div class="layout-row gap-10 address-points-row">
              <app-availability-location-point
                [label]="locationViews[i].startLabel"
                [pointType]="avail.locationSettings?.departurePointType"
                [homeDisplay]="locationViews[i].startHomeDisplay"
                [servicePointId]="avail.locationSettings?.departureId"
                [servicePointPlace]="locationViews[i].startServicePointPlace"
                [customAddress]="avail.locationSettings?.departurePoint"
                (onPointTypeChange)="onPointTypeChange(avail, i, 'departure', $event)"
                (onServicePointChange)="onServicePointChange(avail, i, 'departure', $event)"
                (onCustomAddressChange)="onCustomAddressChange(avail, i, 'departure', $event)">
              </app-availability-location-point>

              <app-availability-location-point
                [label]="locationViews[i].endLabel"
                [pointType]="avail.locationSettings?.destinationPointType"
                [homeDisplay]="locationViews[i].endHomeDisplay"
                [servicePointId]="avail.locationSettings?.destinationId"
                [servicePointPlace]="locationViews[i].endServicePointPlace"
                [customAddress]="avail.locationSettings?.destinationPoint"
                (onPointTypeChange)="onPointTypeChange(avail, i, 'destination', $event)"
                (onServicePointChange)="onServicePointChange(avail, i, 'destination', $event)"
                (onCustomAddressChange)="onCustomAddressChange(avail, i, 'destination', $event)">
              </app-availability-location-point>
            </div>
          </div>
        </div>

        <hr *ngIf="i < availabilities.length - 1" class="item-divider">
      </ng-container>

      <!-- Assign to Route -->
      <div *ngIf="isCreate" class="route-picker-section layout-column margin-top-10">
        <span class="br-body-2 font-weight-600 primary-100" translate>Assign to Route</span>
        <hr>

        <div *ngIf="loadingRoutes" class="layout-row layout-align-center-center padding-10">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <div *ngIf="!loadingRoutes && !dayRoutes.length" class="br-body-2 gray-101 padding-5" translate>
          No routes available for this day
        </div>

        <div *ngIf="!loadingRoutes && dayRoutes.length" class="layout-column route-list">
          <div *ngFor="let route of dayRoutes"
               class="layout-row layout-align-start-center route-row"
               [class.disabled]="!isRouteSelectable(route)">
            <app-bringoz-radio-button
              [value]="route.id"
              [isSelected]="route.id === selectedRouteId"
              (onValueChange)="isRouteSelectable(route) && onSelectRoute($event)">
            </app-bringoz-radio-button>
            <span class="br-body-2 margin-left-5 flex text-ellipsis">{{ route.name || route.resource?.agentName }}</span>
            <span class="br-body-2 gray-101 margin-left-5" *ngIf="route.totals?.totalStopsCount != null">
              {{ route.totals.totalStopsCount }} {{ 'Stops' | translate }}
            </span>
            <app-bringoz-status-tag class="margin-left-5" [status]="route.status"></app-bringoz-status-tag>
          </div>
        </div>
      </div>

      <div *ngIf="errorMessage" class="layout-row margin-top-5">
        <span class="br-body-2 error-text">{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex layout-row layout-align-center-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>

    <!-- Footer Actions -->
    <hr class="main-divider">
    <div class="layout-row layout-align-start-center padding-5">
      <bringoz-button type="tertiary"
                      (onClick)="onCancel()">
        <span class="br-body-1 font-weight-400 gray-101" translate>Cancel</span>
      </bringoz-button>
      <span class="flex"></span>
      <bringoz-button type="tertiary"
                      buttonType="submit"
                      [isDisabled]="!!errorMessage">
        <span class="br-body-1 font-weight-400 blue-104" translate>Submit</span>
      </bringoz-button>
    </div>
  </form>
</div>
